import TableComponents from '../../components/TableComponents'
import { useState, useEffect, useCallback } from 'react'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import SoundForm from './Form/SoundForm'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'
import { AlertPopup, handdleOpenAlert } from '../../components/StyleComponent'
import ModalDelete from '../../components/ModalDelete'

export default function Sound({ update, create, remove }) {
    const [open, setOpen] = useState(false)
    const [row, setRow] = useState('')
    const [data, setData] = useState('')
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState('')
    const [openAlert, setOpenAlert] = useState(false)
    const [error, setError] = useState(false)

    const columns = [
        {
            id: 'id',
            label: 'No.',
            width: '5%',
            align: 'center',
        },
        {
            id: 'name',
            label: 'Name',
            width: '10%',
            align: 'left',
        },
        { id: 'file_name', label: 'File name', width: '20%', align: 'left' },
        {
            id: 'sound_url',
            label: '',
            width: '30%',
            align: 'left',
            type: 'player',
        },
        { id: 'createdAt', label: 'Create at', width: '20%', align: 'left' },
        {
            id: 'actions',
            label: '',
            width: '5%',
            align: 'center',
        },
    ]

    const handleAlert = (message, status) => {
        handdleOpenAlert(setOpenAlert, setMessage, message, status)
    }

    const getSoundById = useCallback(async (sound_id) => {
        try {
            const res = await axiosInstance.get(
                `${urlConfig.sound}/${sound_id}`,
                {
                    responseType: 'arraybuffer',
                },
            )
            if (res.data) {
                const blob = new Blob([res.data], { type: 'audio/wav' })
                return URL.createObjectURL(blob)
            }

            return null
        } catch (error) {
            // handleAlert(
            //     error.response?.data?.message ||
            //         'Failed to fetch sound details',
            //     'error',
            // )
            return null
        }
    }, [])

    const getSounds = useCallback(async () => {
        setData('')
        try {
            setError(false)
            const res = await axiosInstance.get(urlConfig.sound)
            if (res.data.message && res.data.message.length > 0) {
                const soundData = await Promise.all(
                    res.data.message.map(async (item, index) => {
                        const sound_url = await getSoundById(item.sound_id)
                        return {
                            ...item,
                            id: index + 1,
                            createdAt: formatDate(item.createdAt),
                            sound_url,
                        }
                    }),
                )

                setData(soundData || [])
            } else {
                setData([])
            }
        } catch (error) {
            setError(true)
            handleAlert(
                error.response?.data?.message || 'Failed to fetch sounds',
                'error',
            )
        }
    }, [getSoundById])

    const handleDelete = async () => {
        setLoading(true)
        try {
            await axiosInstance.delete(`${urlConfig.sound}/${row.sound_id}`)
            handleAlert('Sound deleted successfully.', 'success')
            getSounds()
            setOpen(false)
        } catch (error) {
            handleAlert(
                error.response?.data?.message || 'Failed to delete sound',
                'error',
            )
        } finally {
            setLoading(false)
        }
    }

    const listMenu = [
        update && {
            title: 'Edit',
            icon: <EditOutlinedIcon color='warning' />,
            action: () => {
                setOpen('edit')
            },
        },
        remove && {
            title: 'Delete',
            icon: <DeleteOutlineOutlinedIcon color='error' />,
            action: () => {
                setOpen('delete')
            },
        },
    ].filter(Boolean)

    useEffect(() => {
        getSounds()
    }, [getSounds])

    return (
        <div>
            <TableComponents
                columns={columns}
                data={data}
                loading={loading}
                error={error}
                refresh={getSounds}
                button={{
                    title: 'ADD SOUND',
                    action: () => setOpen('add'),
                }}
                setAction={setRow}
                MenuList={listMenu}
                disabledButton={create}
            />
            {open === 'add' && (
                <SoundForm
                    open={open === 'add'}
                    setOpen={setOpen}
                    handleAlert={handleAlert}
                    refresh={getSounds}
                />
            )}
            {open === 'edit' && (
                <SoundForm
                    open={open === 'edit'}
                    setOpen={setOpen}
                    row={row}
                    handleAlert={handleAlert}
                    refresh={getSounds}
                />
            )}
            <ModalDelete
                open={open === 'delete'}
                setOpen={setOpen}
                message={row?.name}
                disabled={loading}
                onSubmit={handleDelete}
            />
            <AlertPopup
                message={message}
                open={openAlert}
                setOpen={setOpenAlert}
            />
        </div>
    )
}
const formatDate = (isoString) => {
    const date = new Date(isoString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`
}
